/*
 * @author Andrey Patyuchenko
 * @email  apatyuchenko@atlassian.com
 * @email  andrey.patyuchenko@gmail.com
 * @date   3/16/22
 */

import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {persistState} from "../helpers";

export type RecentEventTypesState = string[];

const STORAGE_KEY = 'vega.state.recent-event-types';
const storedState = localStorage.getItem(STORAGE_KEY);
const initialState: RecentEventTypesState = storedState ? JSON.parse(storedState) : [];

export const slice = createSlice({
	name: 'recent-event-types',
	initialState,
	reducers: {
		add: (state, action: PayloadAction<string> ) => {
			const newState = [ action.payload, ...state ].filter((v,i,a) => a.indexOf(v) === i).slice(0, 5);
			persistState(STORAGE_KEY, newState);
			return newState;
		},
		remove: (state, action: PayloadAction<string> ) => {
			const newState = state.filter(s => s !== action.payload);
			persistState(STORAGE_KEY, newState);
			return newState;
		},
	},
});

export const {add, remove} = slice.actions;
export default slice.reducer;